export default __webpack_public_path__ + "static/media/29-min.dda540e7.png";